/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UsuarioFiltrarPorCandidatoGet$Params {
  Accept?: string;
  idCompanySession?: string;
  idJobOffer?: string;
  profileReaded?: string;
  idDistrict?: string;
  fromWagePretention?: number;
  untilWagePretention?: number;
  currentlyWorking?: string;
  idJobTitle?: string;
  idArea?: string;
  companyName?: string;
  idBusinessLine?: string;
  idProfession?: string;
  idEducationDegree?: string;
  idLanguage?: string;
  speakingLevel?: string;
  writtenLevel?: string;
  knowledgeAccessLevel?: string;
  knowledgeWordLevel?: string;
  knowledgeExcelLevel?: string;
  knowledgePowerPointLevel?: string;
  knowledgeOutlookLevel?: string;
  otherKnowledge?: string;
  otherKnowledgeLevel?: string;
  userAvatar?: number;
  fromBirthDate?: string;
  untilBirthDate?: string;
  sex?: string;
  firstName?: string;
  lastName?: string;
  idCountry?: string;
  identificationDocument?: string;
  excludeSex?: number;
  excludeKnowledgeAccess?: number;
  excludeKnowledgeWord?: number;
  excludeKnowledgeExcel?: number;
  excludeKnowledgePowerPoint?: number;
  excludeKnowledgeOutlook?: number;
  excludeAge?: number;
  excludeExperience?: number;
  excludeRequestRemuneration?: number;
  excludeEducationDegree?: number;
  skip?: number;
  quantity?: number;
}

export function usuarioFiltrarPorCandidatoGet(http: HttpClient, rootUrl: string, params?: UsuarioFiltrarPorCandidatoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, usuarioFiltrarPorCandidatoGet.PATH, 'get');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.query('idCompanySession', params.idCompanySession, {});
    rb.query('idJobOffer', params.idJobOffer, {});
    rb.query('profileReaded', params.profileReaded, {});
    rb.query('idDistrict', params.idDistrict, {});
    rb.query('fromWagePretention', params.fromWagePretention, {});
    rb.query('untilWagePretention', params.untilWagePretention, {});
    rb.query('currentlyWorking', params.currentlyWorking, {});
    rb.query('idJobTitle', params.idJobTitle, {});
    rb.query('idArea', params.idArea, {});
    rb.query('companyName', params.companyName, {});
    rb.query('idBusinessLine', params.idBusinessLine, {});
    rb.query('idProfession', params.idProfession, {});
    rb.query('idEducationDegree', params.idEducationDegree, {});
    rb.query('idLanguage', params.idLanguage, {});
    rb.query('speakingLevel', params.speakingLevel, {});
    rb.query('writtenLevel', params.writtenLevel, {});
    rb.query('knowledgeAccessLevel', params.knowledgeAccessLevel, {});
    rb.query('knowledgeWordLevel', params.knowledgeWordLevel, {});
    rb.query('knowledgeExcelLevel', params.knowledgeExcelLevel, {});
    rb.query('knowledgePowerPointLevel', params.knowledgePowerPointLevel, {});
    rb.query('knowledgeOutlookLevel', params.knowledgeOutlookLevel, {});
    rb.query('otherKnowledge', params.otherKnowledge, {});
    rb.query('otherKnowledgeLevel', params.otherKnowledgeLevel, {});
    rb.query('userAvatar', params.userAvatar, {});
    rb.query('fromBirthDate', params.fromBirthDate, {});
    rb.query('untilBirthDate', params.untilBirthDate, {});
    rb.query('sex', params.sex, {});
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('idCountry', params.idCountry, {});
    rb.query('identificationDocument', params.identificationDocument, {});
    rb.query('excludeSex', params.excludeSex, {});
    rb.query('excludeKnowledgeAccess', params.excludeKnowledgeAccess, {});
    rb.query('excludeKnowledgeWord', params.excludeKnowledgeWord, {});
    rb.query('excludeKnowledgeExcel', params.excludeKnowledgeExcel, {});
    rb.query('excludeKnowledgePowerPoint', params.excludeKnowledgePowerPoint, {});
    rb.query('excludeKnowledgeOutlook', params.excludeKnowledgeOutlook, {});
    rb.query('excludeAge', params.excludeAge, {});
    rb.query('excludeExperience', params.excludeExperience, {});
    rb.query('excludeRequestRemuneration', params.excludeRequestRemuneration, {});
    rb.query('excludeEducationDegree', params.excludeEducationDegree, {});
    rb.query('skip', params.skip, {});
    rb.query('quantity', params.quantity, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

usuarioFiltrarPorCandidatoGet.PATH = '/usuario/filtrar-por-candidato';
